"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthScope;
(function (AuthScope) {
    AuthScope["AUTH"] = "auth";
    AuthScope["PLATFORM"] = "platform";
    AuthScope["CONNECTIONS"] = "connections";
    AuthScope["PUBLISHERS"] = "publishers";
    AuthScope["IP_BLOCKER"] = "ip_blocker";
    AuthScope["MONEY_BOOKER"] = "moneybooker";
    AuthScope["ALGOTRADER"] = "algotrader";
    AuthScope["SKYNET"] = "skynet";
    AuthScope["AUTOSCALER"] = "autoscaler";
    AuthScope["NIGHTWATCH"] = "nightwatch";
    AuthScope["DISPLAY"] = "display";
    AuthScope["OPEN_RTB"] = "open_rtb";
    AuthScope["ADVERTISERS"] = "advertisers";
    AuthScope["DSP_GATEWAY"] = "dsp_gateway";
    AuthScope["CAPTAINS_LOG"] = "captains_log";
    AuthScope["BI"] = "bi";
    AuthScope["CONTENT"] = "content";
    AuthScope["CAPCHU"] = "capchu";
    AuthScope["CAMPAIGN_DUPLICATOR"] = "campaign_duplicator";
    AuthScope["VAULT"] = "vault";
    AuthScope["NETWORK"] = "network";
    AuthScope["VROKU"] = "vroku";
    AuthScope["MESSAGES"] = "messages";
    AuthScope["REPORTING"] = "reporting";
    AuthScope["BI_DASHBOARD"] = "bi_dashboard";
    AuthScope["BI_DASHBOARDS"] = "bi_dashboards";
    AuthScope["GAMES"] = "games";
    AuthScope["VPM"] = "vpm";
    AuthScope["WEB_DIRECTORY"] = "web_directory";
    AuthScope["SITES"] = "sites";
    AuthScope["FEATURE_TOGGLES"] = "feature_toggles";
    AuthScope["USER_NOTIFICATIONS"] = "user_notifications";
    AuthScope["CMS"] = "cms";
    AuthScope["ENTERPRISE"] = "enterprise";
    /**
     * Externals
     */
    AuthScope["KIBANA"] = "kibana";
})(AuthScope || (AuthScope = {}));
exports.default = AuthScope;
